import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12,3H4A2,2,0,0,0,2,5V6A2,2,0,0,0,4,8h8a2,2,0,0,0,2-2V5A2,2,0,0,0,12,3Zm.5,3a.5.5,0,0,1-.5.5H4A.5.5,0,0,1,3.5,6V5A.5.5,0,0,1,4,4.5h8a.5.5,0,0,1,.5.5ZM14,12.75a.76.76,0,0,1-.75.75H2.75a.75.75,0,0,1,0-1.5h10.5A.76.76,0,0,1,14,12.75Zm0-3a.76.76,0,0,1-.75.75H2.75a.75.75,0,0,1,0-1.5h10.5A.76.76,0,0,1,14,9.75Z';
const draw24px =
  'M20,3H4A2,2,0,0,0,2,5V7A2,2,0,0,0,4,9H20a2,2,0,0,0,2-2V5A2,2,0,0,0,20,3Zm.5,4a.5.5,0,0,1-.5.5H4A.5.5,0,0,1,3.5,7V5A.5.5,0,0,1,4,4.5H20a.5.5,0,0,1,.5.5ZM22,19.75a.76.76,0,0,1-.75.75H2.75a.75.75,0,0,1,0-1.5h18.5A.76.76,0,0,1,22,19.75Zm0-8a.76.76,0,0,1-.75.75H2.75a.75.75,0,0,1,0-1.5h18.5A.76.76,0,0,1,22,11.75Zm0,4a.76.76,0,0,1-.75.75H2.75a.75.75,0,0,1,0-1.5h18.5A.76.76,0,0,1,22,15.75Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MakeCurrentIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'makeCurrent'),
) as IconWithRender;

MakeCurrentIcon.displayName = 'MakeCurrentIcon';
MakeCurrentIcon.propTypes = Icon.propTypes;
MakeCurrentIcon.renderIcon = (props) => <MakeCurrentIcon {...props} />;
export default MakeCurrentIcon;
